import {
  getEditFormInitialValues,
  getMoreOptionsInitialValues,
  getNotificationDraftsInitialValues,
  getNotificationToggleInitialValues
} from 'features/event_type_editor'

import { getNotificationSettingsInitialValues } from './notification_settings'

const mergeInitialValues = (...initialValuesBySection) => (
  initialValuesBySection.reduce((mergedValues, initialValues) => ({
    ...mergedValues,
    ...initialValues
  }), {})
)

export const getMergedInitialValues = ({ eventType, defaultAvailabilityRules }) => mergeInitialValues(
  getEditFormInitialValues({
    eventType,
    defaultAvailabilityRules,
    paymentsUpfrontVariant: null
  }),
  getMoreOptionsInitialValues({
    eventType,
    defaultAvailabilityRules,
    showPaymentsUpfront: false,
    excludeLocation: true
  }),
  getNotificationSettingsInitialValues(eventType),
  getNotificationToggleInitialValues(eventType),
  getNotificationDraftsInitialValues(),
  {
    isPublic: Boolean(eventType.public),
    // Draft form value (like `color`) rather than its own PATCH: the header kebab's
    // "Page language" row stages a selection here, and it's sent with the next save
    // instead of updating on its own. See header_more_menu.js/page_language_menu.js.
    locale: eventType.locale
  }
)
